var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 30,
    viewBox: "0 0 51 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_4778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8892 13.3078C25.871 14.7493 27.1648 15.5537 28.1393 16.032C29.1406 16.5227 29.4769 16.8373 29.473 17.2762C29.4655 17.9478 28.6743 18.2442 27.9339 18.2557C26.6421 18.2759 25.8911 17.9045 25.294 17.6236L24.8286 19.8165C25.4277 20.0946 26.537 20.337 27.6873 20.3477C30.3875 20.3477 32.154 19.0053 32.1636 16.924C32.1741 14.2825 28.5358 14.1363 28.5607 12.9556C28.5692 12.5976 28.9084 12.2156 29.6517 12.1185C30.0196 12.0694 31.0352 12.0318 32.1866 12.5658L32.6385 10.4441C32.0193 10.217 31.2235 9.9996 30.2326 9.9996C27.6911 9.9996 25.9036 11.3603 25.8892 13.3078ZM36.9809 10.1824C36.4879 10.1824 36.0724 10.472 35.8869 10.9165L32.0298 20.1918H34.7281L35.265 18.6973H38.5621L38.8736 20.1918H41.2518L39.1765 10.1824H36.9809ZM37.3584 12.8863L38.1371 16.6449H36.0045L37.3584 12.8863ZM22.6178 10.1825L20.4909 20.1917H23.0621L25.1879 10.1822H22.6178M18.8141 10.1822L16.1379 16.9952L15.0553 11.2024C14.9283 10.5558 14.4267 10.1824 13.8696 10.1824H9.49487L9.43359 10.473C10.3317 10.6693 11.3521 10.9859 11.9703 11.3246C12.3487 11.5315 12.4566 11.7124 12.5809 12.2041L14.6313 20.1918H17.3484L21.5141 10.1824L18.8141 10.1822Z",
    fill: "url(#paint0_linear_214_4778)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.758269,
    y: 0.324675,
    width: 49.3507,
    height: 29.2208,
    rx: 2.92208,
    stroke: "#9A9A9A",
    strokeWidth: 0.649351
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_4778",
    x1: 1472.24,
    y1: 41.1058,
    x2: 1502.41,
    y2: -1021.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_4778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8182,
    height: 10.3896,
    fill: "white",
    transform: "translate(9.43359 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.253de25ac1893e95f44e4c4709e06264.svg";
export { ForwardRef as ReactComponent };